import request from "@/utils/request";

// 获取用户列表
export function queryUserList() {
  return request({
    url: "/user/getUserList",
    method: "get",
  });
}

// 获取角色列表
export function queryUserRoleList(data) {
  return request({
    url: "/user/getRoleList",
    method: "post",
    data,
  });
}
